import { render } from "./Keypad.vue?vue&type=template&id=1ede249e&scoped=true"
import script from "./Keypad.vue?vue&type=script&lang=js"
export * from "./Keypad.vue?vue&type=script&lang=js"

import "./Keypad.vue?vue&type=style&index=0&id=1ede249e&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ede249e"]])

export default __exports__